<template>
  <div>
    <v-button class="mb10" type="primary" name="" @click="openAddModel"
      >定义 Topic</v-button
    >
    <!-- <v-input
      class="ml10"
      v-model="searchData"
      placeholder="请输入 Topic"
      suffix-icon="v-icon-search"
      @change="searchdata"
    >
    </v-input> -->
    <div>
      <vxe-table row-id="topic_id" :data="table" align="left">
        <vxe-table-column
          field="topic_typeview"
          show-overflow
          min-width="50"
          title="功能"
        ></vxe-table-column>
        <vxe-table-column
          field="topic"
          show-overflow
          min-width="420"
          title="Topic"
        ></vxe-table-column>
        <vxe-table-column
          field="topic_powerview"
          show-overflow
          min-width="80"
          title="操作权限"
        ></vxe-table-column>
        <vxe-table-column
          field="topic_desc"
          show-overflow
          min-width="220"
          title="描述"
        ></vxe-table-column>
        <vxe-column title="操作" min-width="140">
          <template v-slot="slotProps">
            <span class="handle-button"
              ><v-button
                size="S"
                type="text"
                name="btn-text1"
                slot="reference"
                @click="openViewModel(slotProps.row)"
                >查看</v-button
              ></span
            >
            <span class="handle-button"
              ><v-button
                size="S"
                type="text"
                name="btn-text1"
                slot="reference"
                @click="openUpdataModel(slotProps.row)"
                >编辑</v-button
              ></span
            >
            <span class="handle-button"
              ><v-button
                size="S"
                type="text"
                name="btn-text1"
                slot="reference"
                @click="openDelModel(slotProps.row)"
                >删除</v-button
              ></span
            >
          </template>
        </vxe-column>
      </vxe-table>
    </div>
    <AddTopic
      :showInputDialog.sync="AddTopicloading"
      ref="AddTopic"
      @getData="getData"
      :productKey="productKey"
    ></AddTopic>
    <UpdataTopic
      :showInputDialog.sync="UpdataTopicloading"
      ref="UpdataTopic"
      @getData="getData"
      :updatainfo="updatainfo"
      :productId="productId"
    ></UpdataTopic>
    <Del
      :showInputDialog.sync="Delloading"
      ref="Del"
      @getData="getData"
      :topicId="topicId"
    ></Del>
    <UpdataAndview
      :showInputDialog.sync="UpdataAndviewloading"
      ref="UpdataAndview"
      :id="id"
      :category="category"
      topicType="diy"
      @getData="getData"
    ></UpdataAndview>
  </div>
</template>
<script>
import AddTopic from "./add-diy-topic.vue";
import UpdataTopic from "./updata-diy-topic.vue";
import Del from "./del.vue";
import { BASE_TOPIC_TYPE, PUB_SUB } from "@/common/libs/Contains";
import UpdataAndview from "@/components/product/topic-list/view-params.vue";

export default {
  components: { AddTopic, UpdataTopic, Del, UpdataAndview },
  props: {
    productKey: {},
    productId: {},
  },
  data() {
    return {
      searchData: "",
      AddTopicloading: false,
      UpdataTopicloading: false,
      Delloading: false,
      topicId: "",
      updatainfo: {},
      table: [],
      id: "",
      category: "",
      UpdataAndviewloading: false,
    };
  },
  created() {
    this.getData();
  },

  methods: {
    async getData() {
      const subData = {
        app_id: sessionStorage.getItem("appid") || "",
        product_key: this.productKey,
        topic_type: "diy",
      };
      const res = await this.$post(
        "/td/td-iot-api/iot/product/topic/v1",
        subData,
        false
      );
      if (res.code === 0) {
        this.table = res.data;
        this.table.map((item) => {
          item.topic_typeview = BASE_TOPIC_TYPE[item.topic_type];
          item.topic_powerview = PUB_SUB[item.topic_power];
        });
      } else {
        if (res.code == "100410") {
          setTimeout(() => {
            this.getData();
          }, 1000);
        } else {
          this.$message.error(res.msg);
        }
      }
    },
    openAddModel() {
      this.AddTopicloading = !this.AddTopicloading;
    },
    openUpdataModel(row) {
      this.updatainfo = row;
      this.UpdataTopicloading = !this.UpdataTopicloading;
    },
    openDelModel(row) {
      this.topicId = row.topic_id;
      this.Delloading = !this.Delloading;
    },
    openViewModel(row) {
      this.id = row.topic_id;
      this.category = row.topic_power === PUB_SUB.sub ? "input" : "output";
      this.UpdataAndviewloading = !this.UpdataAndviewloading;
    },
  },
  beforeDestroy() {},
};
</script>

<style lang="scss"></style>
